// Polls "has the documentId been created yet?" until the async pipeline (S3 → scan → confirm webhook → Document)
// resolves it. Used by the contract-dialog composer; the SeV2 composer is push-driven (see waitForUploadedDocumentId).
export const pollForUploadedDocumentId = async (
  fetchDocumentId: (uploadId: string) => Promise<string | null>,
  uploadId: string,
  attempts = 30,
  intervalMs = 1000,
): Promise<string | null> => {
  for (let i = 0; i < attempts; i++) {
    const documentId = await fetchDocumentId(uploadId);
    if (documentId) return documentId;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return null;
};
